import { SUCURSALES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    informacion: null
};

export default function sucursalesReducer(state = initialState, action) {
    switch (action.type) {
        case SUCURSALES.BUSCAR:
            return { ...state, listado: action.payload };

        case SUCURSALES.AGREGAR:
            return { ...state, listado: [action.payload, ...state.listado] };

        case SUCURSALES.EDITAR:
            return {
                ...state,
                listado: state.listado.map(s => s._id === action.payload._id ? action.payload : s)
            };

        case SUCURSALES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(s => s._id !== action.payload)
            };

        case SUCURSALES.DETALLES:
            return { ...state, detalles: action.payload };

        case SUCURSALES.INFORMACION:
            return { ...state, informacion: action.payload };

        case SUCURSALES.LIMPIAR:
            return { ...state, detalles: null, informacion: null };

        default:
            return state;
    }
}
